import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  complianceData: {},
};

const overallComplianceSlice = createSlice({
  name: "overallCompliance",
  initialState,
  reducers: {
    fetchCompliance: (state, action) => {
      state.loading = true;
      state.error = null;
      state.complianceData = {};
    },
    fetchComplianceSuccess: (state, action) => {
      state.loading = false;
      state.complianceData = action.payload?.data || {};
    },
    fetchComplianceFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload?.data?.message || "Failed to fetch compliance data";
    },
  },
});

export const { actions, reducer } = overallComplianceSlice;
export const sliceKey = overallComplianceSlice.name;